import classnames from "classnames";

const TimeSlot = ({
  time,
  isAvailable = true,
  isSoonest = false,
  value,
  isSelected = false,
  onChange,
  "data-testid": testId,
}: {
  time: string;
  isAvailable?: boolean;
  isSoonest?: boolean;
  value: string;
  isSelected?: boolean;
  onChange: (arg: string) => void;
  "data-testid"?: string;
}) => {
  const cursorClass = isAvailable ? "cursor-pointer" : "";
  const classes = classnames(
    "py-4 flex max-h-14 w-full pr-10 border-b border-light-grey items-center",
    {
      "bg-leafly-white text-grey": !isAvailable,
    },
    cursorClass,
  );

  const inputClasses = classnames(
    "w-fit",
    { invisible: !isAvailable },
    cursorClass,
  );

  return (
    <label className={classes} data-testid={testId}>
      <input
        type="radio"
        name="time-slot"
        className={inputClasses}
        disabled={!isAvailable}
        checked={isSelected}
        onChange={() => onChange(value)}
      />
      <span className="flex-grow pl-4">
        {time} {isSoonest && <span>(soonest available)</span>}
      </span>
      {!isAvailable && <span className="text-xs">Unavailable</span>}
    </label>
  );
};

export default TimeSlot;
